import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { LOGIN } from "@/constants/testIds";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  const field = "mt-1.5 h-12 w-full rounded-xl border border-[#E5E0D8] bg-white px-4 outline-none focus:border-[#C59B27] focus:ring-4 focus:ring-[#C59B27]/15";
  return (
    <div className="grid min-h-screen place-items-center bg-[#FDFBF7] px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-[#E5E0D8] bg-white p-7 shadow-[0_30px_60px_-40px_rgba(27,67,50,.5)]">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#1B4332] text-[#F3DB8C]"><Lock className="h-5 w-5" /></span>
        <h1 className="mt-5 font-display text-3xl font-bold text-[#1B4332]">Owner sign in</h1>
        <p className="mt-1 text-sm text-[#5B625D]">Manage RamVilas inventory.</p>
        <label className="mt-6 block text-sm font-medium">Email
          <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid={LOGIN.emailInput} />
        </label>
        <label className="mt-4 block text-sm font-medium">Password
          <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid={LOGIN.passwordInput} />
        </label>
        <Link to="/admin/forgot-password" className="mt-2 block text-right text-sm font-medium text-[#1B4332] hover:underline" data-testid={LOGIN.forgotPasswordLink}>Forgot password?</Link>
        {error && <p className="mt-4 rounded-lg bg-[#F6E4E1] px-3 py-2 text-sm text-[#8A2B1E]" role="alert" data-testid="login-error">{error}</p>}
        <button disabled={busy} className="mt-6 h-12 w-full rounded-full bg-[#1B4332] font-semibold text-white transition-colors hover:bg-[#10291F] disabled:opacity-60" data-testid={LOGIN.submitButton}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <Link to="/" className="mt-5 block text-center text-sm text-[#5B625D] hover:text-[#1B4332]" data-testid="login-back-home">← Back to store</Link>
      </form>
    </div>
  );
}
